export const DATE_UPDATE = '18/05/2023';
export const VERSION = '1.4.0'
